import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a4bba84ca334e0014fca635_1783393186833_d4798699/boxbasket/src/app/shopping-cart/[id]/page.tsx");
